import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../Structure/components/Head/Head';
import Footer from '../../Structure/components/Footer/Footer';

import {getEntityByPermalink, resetinfoEntity} from "../actions/actionsEntity";
import Alert from 'react-s-alert';
import AlertsConteiner from '../../Shared/components/Alerts/AlertsConteiner';
import {ELEMENTS, TIPOS_EVENTOS} from "../../../analytics/config/analyticsParamsFrontEnd.js";
import {browserHistory} from "react-router";
import {
    PATH_BUSCADOR_PETFRIENDLY_PROVINCIA,
    PATH_BUSCADOR_PETFRIENDLY_PROVINCIA_MUNICIPIO,
    PATH_BUSCADOR_PETFRIENDLY_ROOT,
    PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA,
    PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA_MUNICIPIO,
    PATH_PROTECTORA_ID
} from "../../../App/RouterAdopta";
import EntityProtectoraDetailContainer from "./EntityProtectora/EntityProtectoraDetailContainer";
import Breadcrumbs_component from "../../Shared/components/components/Breadcrumbs/Breadcrumbs_component";

import {getSimilarEntitiesRecomendation, resetSimilarEntitiesRecomendation} from "../../Recomendations/actions/actionsRecomendations";
import {getCurrentLocationCoordinates, handleErrorCurrentLocationCoordinates} from '../../../Utils/GeoCoding.js'
import {normalizeName} from '../../../Utils/Analizer.js'
import {sendEvent} from "../../../analytics/analitycs"

import {MAP_TIPOS_ENTITY, TABLET_MAX_WINDOW_WIDTH,} from '../../../config/globalFrontEndConfig.js'
import {ADS_TYPES, AdsManagerContainer} from "../../Ads/components/AdsManagerContainer";
import {DESKTOP_MODE, MOBILE_MODE} from "../../../config/globalFrontEndConfig";

let time_init
//TODO 20/12/22 20:04: en teoria est component debería ser agnostico al tipo de entidad, solo mont el componente
// correspondiente al yipo de entidad de la url y hace las peticiones y son los compoenentes "entityXXXXDetailContainer"
// los que manejan los datos, los métodos y demás no deberían estar acomplados a la protectora ni al nombre
// NOTA: la otro opción es hacer una "EntityDetailPage" por cada entidad, si no se puede hacer agnosito se debería pantear de esa forma

class EntityDetailPage extends Component {

    constructor(props) {
        super(props);
        time_init = new Date().getTime()
        this.state = {
            tipo_entity: undefined,
        }
        this.state.similarEntitiesRecomendationRequested = false;
        const params = props.params
        let tipo_entity;

        if (params.tipo_entity) {
            if (Object.keys(MAP_TIPOS_ENTITY).includes(params.tipo_entity.toLowerCase())) {
                tipo_entity = params.tipo_entity.toLowerCase()

            } else {
                console.log("Tipo entidad no valido -> to /buscar-pet-friendly");
                browserHistory.push(PATH_BUSCADOR_PETFRIENDLY_ROOT)
            }
        } else {
            this.state.filtroEntitySeleccionado.tipo = ["protectora"]
        }
        this.state.config = props.config || {};

        var width = window.innerWidth;
        if (width < TABLET_MAX_WINDOW_WIDTH) {
            this.state.config.elementsPerPage = 4;
            this.state.config.elementsPerRow = 2;
        } else {
            this.state.config.elementsPerPage = 4;
            this.state.config.elementsPerRow = 4;
        }
        this.state.animalsProtectoraRequested = false
        this.state.animalsRecomendationRequested = false

        this.state.tipo_entity = tipo_entity;

        //console.log("EntityDetailPage::componentWillMount() -> Haciendo scrollTop 0 | 0ms");
        $('body,html').stop(true, true).animate({scrollTop: 0}, 0);

        const time_end = new Date().getTime()
        //console.log("EntityDetailPage::constructor()::timing --> [" + (time_end - time_init) + " ms]");
        setTimeout(() => {
            // console.log("EntityDetailPage::constructor() -> sendEvent pageview");
            // console.log({permalink: props.params.permalink});

            sendEvent(TIPOS_EVENTOS.PAGEVIEW, ELEMENTS.ENTITY.ENTITY, {permalink: props.params.permalink})
            if (this.state.similarEntitiesRecomendationRequested
                && this.props.recomendations?.entities?.similar && this.props.recomendations?.entities?.similar.length > 0) {
                sendEvent(TIPOS_EVENTOS.IMPRESION, ELEMENTS.ENTITY.RECOMENDACION_ENTITY_SIMILAR, {
                    permalinkPage: this.props.params.permalink,
                    list: this.props.recomendations?.entities?.similar.map(e => e._id)
                })
            }
        }, 5 * 1000)


        this.loadEntity = this.loadEntity.bind(this);
        this.EventWaitBlock = this.EventWaitBlock.bind(this);
        this.onClickCardRecomendation = this.onClickCardRecomendation.bind(this);
        this.createBreadcrumbsList = this.createBreadcrumbsList.bind(this);
        this.loadSimilarEntitiesRecomendation = this.loadSimilarEntitiesRecomendation.bind(this);
        this.getCurrentLocation = this.getCurrentLocation.bind(this);
    }

    showLoader() {
    }

    getCurrentLocation() {
        //console.log("EntityDetailPage::getCurrentLocation()");
        const that = this;
        getCurrentLocationCoordinates((position) => {
            if (position) {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                //console.log("Current Location Coordinates");
                //console.log(position);
                that.setState({
                    ...that.state,
                    userLocation: pos,
                })
            }
        }, handleErrorCurrentLocationCoordinates, Alert)

    }

    loadEntity(pageNumber) {

        // if (this.props.params?.id) {
        //
        //     const time_end = new Date().getTime()
        //     console.log("EntityDetailPage::loadAnimals()::getEntityByID:timing --> [" + (time_end - time_init) + " ms]");
        //     this.props.getEntityByID(this.props.params.id, "completa", time_init);
        // }
        if (this.props.params?.permalink) {

            const time_end = new Date().getTime()
            // console.log("EntityDetailPage::loadEntity()::getEntityByPermalink:timing --> [" + (time_end - time_init) + " ms]");
            this.props.getEntityByPermalink(this.props.params.permalink, "completa", time_init);
        }
    }


    EventWaitBlock(event) {
    }


    loadSimilarEntitiesRecomendation() {
        //console.log("AnimalDetailPage::loadDataAnimalsRecomendation()");

        const filter = {
            filter: {
                entity_id: this.props.infoEntity._id,
                tipo: [this.props.infoEntity.tipo],
                // ignoreList: ignoreList,
                geo: {
                    // provincia: currentProvinciaDesnorm,
                    provincia: normalizeName(this.props.infoEntity.direccion.provincia),
                    // municipio: currentMunicipioDesnorm,
                    municipio: normalizeName(this.props.infoEntity.direccion.municipio),
                    near: true,
                    maxDistance: 35
                },
            },
            metadata: {
                numElements: this.state.config.elementsPerPage,
                pagNum: 0,
            }
        }

        this.props.getSimilarEntitiesRecomendation(filter);
        this.setState({
            ...this.state,
            similarEntitiesRecomendationRequested: true
        })

    }

    createBreadcrumbsList() {
        let array = []
        let pathTipo = ""
        let tipo = this.props.infoEntity?.tipo?.charAt(0).toUpperCase() + this.props.infoEntity?.tipo?.slice(1)
        tipo = (new RegExp("[aeiou]$").test(tipo)) ? tipo + "s" : tipo + "es"
        array.push({title: "Buscador Pet Friendly", path: PATH_BUSCADOR_PETFRIENDLY_ROOT})
        array.push({
            title: "En " + this.props?.infoEntity?.direccion?.provincia,
            path: normalizeName(PATH_BUSCADOR_PETFRIENDLY_PROVINCIA
                .replace(":provincia", this.props?.infoEntity?.direccion?.provincia?.toLowerCase()))

        })
        if (this.props?.infoEntity?.direccion?.municipio) {
            array.push({
                title: "Cerca de " + this.props?.infoEntity?.direccion?.municipio,
                path: normalizeName(PATH_BUSCADOR_PETFRIENDLY_PROVINCIA_MUNICIPIO
                    .replace(":provincia", this.props?.infoEntity?.direccion?.provincia?.toLowerCase())
                    .replace(":municipio", this.props?.infoEntity?.direccion?.municipio?.toLowerCase()))
            })

            pathTipo = normalizeName(PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA_MUNICIPIO
                .replace(":provincia", this.props?.infoEntity?.direccion?.provincia?.toLowerCase())
                .replace(":municipio", this.props?.infoEntity?.direccion?.municipio?.toLowerCase())
                .replace(":tipo_entity", this.props.infoEntity.tipo))
        } else {
            pathTipo = normalizeName(PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA
                .replace(":provincia", this.props?.infoEntity?.direccion?.provincia?.toLowerCase())
                .replace(":tipo_entity", this.props.infoEntity.tipo))
        }
        array.push({title: tipo, path: pathTipo})
        return array;
    }

    onClickCardRecomendation(idClick) {
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.ENTITY.RECOMENDACION_ENTITY_SIMILAR, {
            idClick: idClick,
            permalinkPage: this.props.params.permalink
        })
    }

    render() {
        // console.log("EntityDetailPage::render()::timing --> [" + (new Date().getTime() - time_init) + " ms]");
        // console.log("EntityDetailPage::render() state.nombre = '" + this.state.data_entity?.nombre +"'");
        // console.log("EntityDetailPage::render() props.nombre = '" + this.props.infoEntity?.nombre +"'");
        let activeCards = {
            animal: true,
            imagenyvideo: true,
            protectora: false,
            metricasAnimal: false
        };
        let showCardProtectoraDetail = false;
        if (this.props.route.path.startsWith(PATH_PROTECTORA_ID)) {
            showCardProtectoraDetail = true;
        }

        let showEntityDetail = false;

        if (this.props.infoEntity?.nombre) {
            showEntityDetail = true;
        }

        let breadcrumbsList
        try {
            if (this.props.infoEntity && Object.keys(this.props.infoEntity).length !== 0 && !Array.isArray(this.props.infoEntity)) {
                breadcrumbsList = this.createBreadcrumbsList()
            }
        } catch (e) {
            console.error(e)
        }
        //console.log("this.props?.infoEntity?.nombre = '" + this.props?.infoEntity?.nombre + "'");
        //console.log("Entities similares")
        //console.log(this.props.recomendations?.entities?.similar);
        return (
            <div>
                <Head
                    previousPath={"protectoraDetail"}
                />
                <div id="main-content" style={{display: "flex"}}>
                    {DESKTOP_MODE && <div className="col-lg-1">
                        {/*<AdsManagerContainer type={ADS_TYPES.SPLITSCREEN} onlyDesktop/>*/}
                    </div>}
                    <div id="animals-list" className="col-lg-8 detailPage container main-content pageAnimalDetail">
                        {this.props.infoEntity?.nombre && breadcrumbsList &&
                            <Breadcrumbs_component
                                listBreadcrumbs={breadcrumbsList}
                                lastElement={this.props.infoEntity.nombre}
                                showBreadcrumbs={true}
                                HOST={process.env.HOST_ADOPTA}
                                currentPath={this.props.location.pathname}
                            />
                        }

                        {showEntityDetail && this.state.tipo_entity === MAP_TIPOS_ENTITY.protectora.value && (this.props.infoEntity) &&
                            <EntityProtectoraDetailContainer
                                infoEntity={this.props.infoEntity}
                                recomendations={this.props.recomendations}
                                config={this.state.config}
                                userLocation={this.state.userLocation}
                                loader={this.showLoader.bind(this)}
                                waitBlock={this.props.waitBlock}
                                onClickCardRecomendation={this.onClickCardRecomendation}
                            />
                        }
                        {this.state.tipo_entity !== MAP_TIPOS_ENTITY.protectora.value &&
                            <div>DEV: entidad no conocida</div>}


                    </div>
                    {DESKTOP_MODE && <div className="">
                        <AdsManagerContainer type={ADS_TYPES.SKYSCRAPER} onlyDesktop sticky/>
                    </div>}
                </div>
                <Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>

                {this.props.infoEntity && <Footer percent={100} configFooter={{"moreInfo": false}}/>}
            </div>
        );
    }

    componentWillMount() {
        //console.log("EntityDetailPage::componentWillMount()");

        this.props.resetinfoEntity()

        this.props.resetSimilarEntitiesRecomendation()
        const time_end = new Date().getTime()
        // console.log("EntityDetailPage::componentWillMount()::getEntityByID:timing --> [" + (time_end - time_init) + " ms]");
        // this.props.getEntityByID(this.props.params.id, "completa", time_init);
        // console.log("EntityDetailPage::componentWillMount()::getEntityByPermalink:timing --> [" + (time_end - time_init) + " ms]");
        this.props.getEntityByPermalink(this.props.params.permalink, "completa", time_init);

    }

    componentDidMount() {
        // console.log("EntityDetailPage::componentDidMount()");
        //console.log(this.props.infoEntity);
        if (!this.state.userLocation) {
            this.getCurrentLocation()
        }

    }

    componentDidUpdate(prevProps, prevState) {
        // console.log("EntityDetailPage::componentDidUpdate()");
        if (this.props.params.permalink !== prevProps.params.permalink) {
            this.props.resetinfoEntity()

            this.props.resetSimilarEntitiesRecomendation()

            this.setState({
                ...this.state,
                similarEntitiesRecomendationRequested: false,
            })
            this.loadEntity(0)
            //console.log("EntityDetailPage::componentDidUpdate() -> Haciendo scrollTop 2 | 0ms");
            $('body,html').stop(true, true).animate({scrollTop: 0}, 0);
        }

        if (!this.state.similarEntitiesRecomendationRequested
            && (!this.props.recomendations?.entities?.similar || Object.keys(this.props.recomendations?.entities?.similar).length === 0 || this.props.recomendations?.entities?.similar?.length === 0)
            && this.props.infoEntity?._id) {

            this.loadSimilarEntitiesRecomendation()


        }
        // if (this.state.similarEntitiesRecomendationRequested
        //     && this.props.recomendations?.entities?.similar
        //     && !arrayEquals(prevProps.recomendations?.entities?.similar, this.props.recomendations?.entities?.similar)) {
        //
        //     console.log("hay entitites recomendadas");
        //     sendEvent(TIPOS_EVENTOS.IMPRESION, ELEMENTS.ENTITY.RECOMENDACION_ENTITY_SIMILAR, {
        //         permalinkPage: this.props.params.permalink,
        //         list: this.props.recomendations?.entities?.similar.map(e => e._id)
        //     })
        // } else {
        //     console.log("no hay entities recomendadas");
        // }
    }

}

function mapStateToProps(state, ownProps) {
    return {
        infoEntity: state.entity.infoEntity,
        recomendations: {
            entities: {
                similar: state.recomendations.entities?.similar
            },
        },
        paramsFilter: state.filterEntities.params,

    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    getEntityByPermalink,
    getSimilarEntitiesRecomendation,
    resetSimilarEntitiesRecomendation,
    resetinfoEntity,
})(EntityDetailPage)
